import React from 'react'
import { Flex } from 'reflexbox'
import UiLabel from 'ui-components/lib/components/Label'

export const Label = ({ children }) => (
  <Flex width={1} props mb={2}>
    <UiLabel>{children}</UiLabel>
  </Flex>
)
